import { CheckCircle } from "flowbite-react-icons/solid";
import { useCallback } from "preact/hooks";
import PropTypes from "prop-types";
import toast from "react-hot-toast";
import DonationTrainOverlayRuleset from "./donation-train-overlay-ruleset.jsx";

DonationTrainOverlayRulesets.propTypes = {
  rulesets: PropTypes.array.isRequired,
  createRuleset: PropTypes.func.isRequired,
  updateRuleset: PropTypes.func.isRequired,
  deleteRuleset: PropTypes.func.isRequired,
};

const defaultRuleset = {
  id: null,
  donationValueMin: 5,
  donationValueMax: 999999,
  donationsCountMin: 4,
  active: true,
  timer: 5,
  allowTrainCreation: true,
};

export function DonationTrainOverlayRulesets({
  rulesets,
  updateRuleset,
  createRuleset,
  deleteRuleset,
}) {
  const didSave = useCallback((reset = false) => {
    toast(
      <>
        <CheckCircle />
        <span>Train rules {reset ? "reset" : "updated"}</span>
      </>,
      {
        position: "top-center",
        className: "alert-success text-white",
      },
    );
  }, []);

  const onSaveHandler = useCallback(
    (ruleset) => {
      if (ruleset.id) {
        updateRuleset(ruleset);
      } else {
        createRuleset(ruleset);
      }

      didSave();
    },
    [updateRuleset, createRuleset, didSave],
  );

  const onResetHandler = useCallback(
    (ruleset) => {
      deleteRuleset(ruleset);
      didSave(true);
    },
    [deleteRuleset, didSave],
  );

  return (
    <DonationTrainOverlayRuleset
      onSave={onSaveHandler}
      onReset={onResetHandler}
      ruleset={rulesets[0] || defaultRuleset}
    />
  );
}
